/*
 * PrimeReact Dialog + inline Calendar render outside Tamagui; these rules scope
 * layout/density to `.member-journey-milestone-dialog` only.
 */
.member-journey-milestone-dialog.p-dialog {
    width: min(98vw, 36rem) !important;
    max-width: 36rem;
    max-height: none !important;
    margin: 0.75rem !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: visible;
}

.member-journey-milestone-dialog .p-dialog-header {
    flex-shrink: 0;
}

.member-journey-milestone-dialog .p-dialog-content {
    flex: 0 0 auto;
    overflow: visible !important;
    padding: 0.35rem 0.5rem 0.25rem;
}

.member-journey-milestone-dialog .p-dialog-footer {
    flex-shrink: 0;
}

.member-journey-milestone-dialog .p-datepicker,
.member-journey-milestone-dialog .p-datepicker-inline {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    font-size: 0.75rem;
    padding: 0.2rem !important;
}

.member-journey-milestone-dialog .p-datepicker-header {
    padding: 0.2rem 0.3rem !important;
}

.member-journey-milestone-dialog .p-datepicker-title {
    font-size: 0.8rem !important;
}

.member-journey-milestone-dialog .p-datepicker-header .p-datepicker-prev,
.member-journey-milestone-dialog .p-datepicker-header .p-datepicker-next {
    width: 1.65rem !important;
    height: 1.65rem !important;
}

.member-journey-milestone-dialog .p-datepicker-calendar-container table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
}

.member-journey-milestone-dialog .p-datepicker-calendar thead > tr > th {
    padding: 0.1rem 0 !important;
    font-size: 0.65rem !important;
    font-weight: 600;
}

.member-journey-milestone-dialog .p-datepicker-calendar td {
    padding: 0.04rem !important;
}

.member-journey-milestone-dialog .p-datepicker-calendar td > span {
    width: 1.55rem !important;
    height: 1.55rem !important;
    max-width: 100%;
    min-width: 0 !important;
    margin: 0 auto;
    line-height: 1.55rem !important;
    font-size: 0.7rem !important;
}

.member-journey-milestone-dialog .p-timepicker {
    padding: 0.3rem 0.2rem !important;
    font-size: 0.75rem !important;
    gap: 0.25rem !important;
}

.member-journey-milestone-dialog .p-timepicker span {
    font-size: 0.75rem !important;
}

.member-journey-milestone-dialog .p-datepicker-buttonbar {
    padding: 0.3rem 0.2rem !important;
    gap: 0.35rem;
}

.member-journey-milestone-dialog .p-datepicker-buttonbar .p-button {
    padding: 0.3rem 0.45rem !important;
    font-size: 0.72rem !important;
}

@media (max-width: 380px) {
    .member-journey-milestone-dialog.p-dialog {
        width: min(100vw - 12px, 36rem) !important;
    }

    .member-journey-milestone-dialog .p-datepicker-calendar td > span {
        width: 1.28rem !important;
        height: 1.28rem !important;
        line-height: 1.28rem !important;
        font-size: 0.62rem !important;
    }
}
